import { useCallback, useMemo } from 'react'
import { useSearchParams } from 'react-router-dom'

export const useAvitoChatDeepLink = () => {
  const [searchParams, setSearchParams] = useSearchParams()
  const requestedTab = searchParams.get('tab')
  const requestedChatId = searchParams.get('chat')

  const updateSearchParams = useCallback(
    (updates: Record<string, string>) => {
      const nextSearchParams = new URLSearchParams(searchParams)
      Object.entries(updates).forEach(([key, value]) => {
        nextSearchParams.set(key, value)
      })
      setSearchParams(nextSearchParams, { replace: true })
    },
    [searchParams, setSearchParams],
  )

  return useMemo(
    () => ({
      isChatsRequested: requestedTab === 'chats',
      requestedChatId,
      setRequestedTab: (tab: string) => updateSearchParams({ tab }),
      setRequestedChat: (chatId: string) => updateSearchParams({ tab: 'chats', chat: chatId }),
    }),
    [requestedChatId, requestedTab, updateSearchParams],
  )
}
